import { AppliedTo, Gender } from '@/app/shared/enums';
import { AddressInsuranceModel } from '@/app/shared/models/insurance/address-insurance.model';
import { ContactInsuranceModel } from '@/app/shared/models/insurance/contact-insurance.model';
import { Model } from '@/app/shared/models/model';

export class IndividualModel extends Model {
  public Name?: string;
  public Type?: AppliedTo;
  public Document?: string;
  public DocumentType?: string;
  public Birthdate?: Date;
  public Gender?: Gender;

  public Contacts: ContactInsuranceModel[] = [];
  public Addresses: AddressInsuranceModel[] = [];

  constructor() {
    super();
    this.DocumentType = 'CPF';
    this.Document = '';
  }
}
